import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, Teleport as _Teleport, Fragment as _Fragment } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-arrow-left p-pr-2" }, null, -1)
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" Volver a Profesores ")
const _hoisted_3 = [
  _hoisted_1,
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_StaffMemberSelector = _resolveComponent("StaffMemberSelector")!
  const _component_TeacherTagTable = _resolveComponent("TeacherTagTable")!
  const _component_TeacherDetailTable = _resolveComponent("TeacherDetailTable")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.teachersSelectorDiv && _ctx.activeIndex === 2)
      ? (_openBlock(), _createBlock(_Teleport, {
          key: 0,
          to: _ctx.teachersSelectorDiv
        }, [
          (!_ctx.viewDetail)
            ? (_openBlock(), _createBlock(_component_StaffMemberSelector, {
                key: 0,
                hasTeacherStatus: true,
                placeholder: 'Profesor/Coordinador',
                allStaff: _ctx.allTeachers,
                modelValue: _ctx.selectedTeacher,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_ctx.selectedTeacher = $event))
              }, null, 8, ["allStaff", "modelValue"]))
            : (_openBlock(), _createElementBlock("span", {
                key: 1,
                style: {"cursor":"pointer"},
                class: "tags-title",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.changeView()))
              }, _hoisted_3))
        ], 8, ["to"]))
      : _createCommentVNode("", true),
    (!_ctx.viewDetail)
      ? (_openBlock(), _createBlock(_component_TeacherTagTable, {
          key: 1,
          loading: _ctx.loading || _ctx.staffIsLoading,
          summaries: _ctx.summaries,
          teacher: _ctx.selectedTeacher || _ctx.allTeachers[0],
          allTeachers: _ctx.allTeachers,
          feedbacks: _ctx.feedbacks,
          dateColumns: _ctx.dateColumns,
          classes: _ctx.classes,
          evaluateSummary: _ctx.EvaluateSummary.teacher,
          onChangeView: _ctx.changeView,
          classesWithStudentAttendances: _ctx.classesWithStudentAttendances
        }, null, 8, ["loading", "summaries", "teacher", "allTeachers", "feedbacks", "dateColumns", "classes", "evaluateSummary", "onChangeView", "classesWithStudentAttendances"]))
      : (_openBlock(), _createBlock(_component_TeacherDetailTable, {
          key: 2,
          selectedClass: _ctx.selectedClass,
          evaluateSummary: _ctx.EvaluateSummary.teacher,
          staffMember: _ctx.selectedTeacher || _ctx.allTeachers[0],
          allTeachers: _ctx.allTeachers,
          feedbacks: _ctx.feedbacks,
          classes: _ctx.classes,
          summaries: _ctx.summaries,
          classesWithStudentAttendances: _ctx.classesWithStudentAttendances
        }, null, 8, ["selectedClass", "evaluateSummary", "staffMember", "allTeachers", "feedbacks", "classes", "summaries", "classesWithStudentAttendances"]))
  ], 64))
}